import get from '@invitato/helpers/dist/getLocale';

export default {
  closingTextInvitation: get(
    'Sampai bertemu di hari pernikahan!', 
    'See you on our Wedding Day!'),
  closingTextAnnouncement: get(
    'Terimakasih atas doa dan ucapannya.', 
    'Thank you for your prayers and wihses.'),
};